// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1A2y5","badges":"styles_badges__3IN1V"};